import React from "react";
import TalkToOurTeamBTN from "../Coman/TalkToOurTeamBTN";

export default function CryptoBankingHero() {
  return (
    <>
      <section
        className="feature-section py_150"
        aria-label="crypto-banking-platform-development"
        style={{
          backgroundImage:
            "url(assets/img/crypto-g-dev/crypto-banking-platform-development.jpg)",
        }}
      >
        <div className="auto-container py-4">
          <div className="row align-items-center pb_100">
            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
              <div className="content-box mr_40">
                <div data-animation-box className="sec-title mb_25">
                  <h2 className="text-white">
                    Crypto Banking Platform Development
                  </h2>
                </div>
                <div className="text-box">
                  <p className="text-white">
                    Our crypto banking solutions are designed to empower users
                    with a seamless digital banking experience, fully tailored
                    to the unique demands of the cryptocurrency market.
                  </p>
                </div>
              </div>
              <div className="btn-box">
                <TalkToOurTeamBTN />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 image-column"></div>
          </div>
        </div>
      </section>
    </>
  );
}
